<template>
    <div class="page-banner">
        <h1 class="banner-title">
            <b>{{this.productTitle}}</b>
        </h1>
    </div>
</template>

<script>

import { mapState, mapMutations } from 'vuex'

export default {
    name: 'Banner',
    data () {
        return {
            timeSize: null,
            startTime: ''
        }
    },
    computed: {
        ...mapState(['lang', 'productTitle'])
    },
    created () {
        this.getHomeInfo()
    },
    methods: {
        ...mapMutations(['setProductTitle']),
        getHomeInfo () {
            this.$Api.getHomeInfo({}).then((data) => {
                if (data && data.conference && data.conference.name) {
                    this.setProductTitle(data.conference.name)
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
    .page-banner {
        height: 56.204vw;
        background: url('../assets/img/new_page_banner.png') no-repeat center center;
        background-size: cover;
        box-sizing: border-box;
        text-align: center;
        .banner-title {
            line-height: 1.2;
            color: #fff;
            font-weight: normal;
            height: 100%;
            display: flex;
            align-items: center;
            justify-self: center;
            b {
                font-size: 6vw;
                display: block;
                line-height: 1.4;
                text-shadow: 0.185vw 0.648vw 9.444vw #002f7a;
                padding: 0 8.5vw;
            }
            span {
                font-size: 2.87vw;
                display: block;
                margin-bottom: 1.389vw;
                text-shadow: 0.185vw 0.648vw 5.444vw #000;
            }
        }
    }
</style>
